import type { FilterValues } from '@features/reports/components/monitoringReports/MonitoringReport/MonitoringReport'
import type { MonitoringReportResponse } from '@lmc/ts-common'
import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import { Spinner } from 'components/generic'
import { NAMESPACE } from 'locale'
import { monitoringReportConstants as translations } from 'locale/monitoringReports'
import { useTranslation } from 'react-i18next'
import DashboardTable from '../DashboardTable/DashboardTable'

interface DashboardBodyProps {
  isLoading: boolean
  filterParams: FilterValues
  data?: MonitoringReportResponse
  reportingId: string
}

export const DashboardBody = ({
  isLoading,
  filterParams,
  data,
  reportingId
}: DashboardBodyProps) => {
  const { t } = useTranslation(NAMESPACE.MONITORING_REPORTS)

  if (isLoading) {
    return <Spinner />
  }
  if (!data || data.count === 0) {
    return (
      <EmptyState
        icon={<NoDataIcon />}
        title={t(translations.EMPTY_STATE_TITLE)}
        description={t(translations.EMPTY_STATE_DESCRIPTION)}
      />
    )
  }

  return (
    <DashboardTable
      filterParams={filterParams}
      dataSource={data.result || []}
      reportingId={reportingId}
    />
  )
}

export default DashboardBody
